import { apiFetch } from "./apiFetch";

export async function submitReview({ bookingId, requestId, stars, comment }) {
  return apiFetch("/api/reviews", {
    method: "POST",
    body: JSON.stringify({
      bookingId: bookingId || undefined,
      requestId: requestId || undefined,
      stars,
      comment: comment || null,
    }),
  });
}

export async function fetchTutorReviews(tutorId) {
  const res = await apiFetch(`/api/reviews/tutor/${encodeURIComponent(tutorId)}`, {
    method: "GET",
  });
  return {
    reviews: Array.isArray(res?.reviews) ? res.reviews : [],
    thumbsUp: Number(res?.thumbsUp || 0),
    thumbsDown: Number(res?.thumbsDown || 0),
    total: Number(res?.total || 0),
  };
}
